import React from "react";
import { Heart, MessageCircle, Repeat2, Share2, BarChart3 } from "lucide-react";
import { cn } from "@/lib/utils";

const fmt = (n) => (typeof n === "number" ? (n >= 1000 ? `${(n / 1000).toFixed(1)}K` : `${n}`) : n);

export const SocialActions = ({ replies, reposts, likes, views, className = "" }) => {
  const [liked, setLiked] = React.useState(false);
  const [reposted, setReposted] = React.useState(false);
  const likeCount = (likes || 0) + (liked ? 1 : 0);
  const repostCount = (reposts || 0) + (reposted ? 1 : 0);

  const Btn = ({ icon: Icon, label, active, activeColor, onClick, testid }) => (
    <button
      type="button"
      onClick={onClick}
      data-testid={testid}
      className={cn(
        "group inline-flex items-center gap-1.5 rounded-full px-2 py-1 text-xs text-slate-400 transition-colors",
        active ? activeColor : "hover:text-cyan-300"
      )}
      aria-label={label}
    >
      <Icon className={cn("h-[18px] w-[18px] transition-transform group-hover:scale-110", active && Icon === Heart && "fill-current")} />
      {label !== null && <span className="tabular-nums">{label}</span>}
    </button>
  );

  return (
    <div className={cn("flex items-center justify-between pt-1", className)}>
      <Btn icon={MessageCircle} label={fmt(replies)} onClick={() => {}} testid="post-reply" />
      <Btn icon={Repeat2} label={fmt(repostCount)} active={reposted} activeColor="text-emerald-400" onClick={() => setReposted((v) => !v)} testid="post-repost" />
      <Btn icon={Heart} label={fmt(likeCount)} active={liked} activeColor="text-pink-400" onClick={() => setLiked((v) => !v)} testid="post-like" />
      {views !== undefined && <Btn icon={BarChart3} label={fmt(views)} onClick={() => {}} testid="post-views" />}
      <Btn icon={Share2} label={null} onClick={() => {}} testid="post-share" />
    </div>
  );
};

export default SocialActions;
